import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=80e3762e&"
import script from "./Ledger.vue?vue&type=script&lang=js&"
export * from "./Ledger.vue?vue&type=script&lang=js&"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=80e3762e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports